import { Box, Typography } from '@mui/material';
import { GameEntity } from '@okletsplay/core';
import { Route } from 'app/enums';
import React, { FC, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ComingSoonGame } from 'modules/games/interfaces';
import { useStyles } from './GameCarouselItem.styles';

interface GameCarouselItemProps {
  game: (GameEntity & { order?: number | undefined }) | ComingSoonGame | null;
}

export const GameCarouselItem: FC<GameCarouselItemProps> = ({ game }) => {
  const navigate = useNavigate();
  const { classes } = useStyles();

  const title = useMemo(() => {
    if (!game?.title) {
      return 'Coming soon...';
    }

    return game.title;
  }, [game?.title]);

  const onClickHandler = useCallback(() => {
    if (!game?.id) {
      return;
    }

    navigate(`${Route.Games}/${game.id}`);
  }, [game?.id, navigate]);

  return (
    <Box className={classes.root} onClick={onClickHandler}>
      <Box className={classes.content}>
        <Box className={classes.imageContainer}>
          <img draggable={false} src={game?.icon} alt={game?.title} />
        </Box>
      </Box>
      <Typography className={classes.title}>{title}</Typography>
    </Box>
  );
};
